import React from 'react';
import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

const { Header } = Layout;

const AppHeader: React.FC = () => {
  const location = useLocation();
  const { t } = useLanguage();
  
  return (
    <Header style={{ position: 'fixed', zIndex: 9999, width: '100%' }}>
      <Link to="/" className="logo">
        <img src="/logo.png" alt="Image Converter Logo"/>
      </Link>
      <Menu
        theme="dark"
        mode="horizontal"
        selectedKeys={[location.pathname]}
        className="menu"
      >
        <Menu.Item key="/">
          <Link to="/">{t('nav.home')}</Link>
        </Menu.Item>
        <Menu.Item key="/about">
          <Link to="/about">{t('nav.about')}</Link>
        </Menu.Item>
        <Menu.Item key="/terms">
          <Link to="/terms">{t('nav.terms')}</Link>
        </Menu.Item>
        <Menu.Item key="/privacy">
          <Link to="/privacy">{t('nav.privacy')}</Link>
        </Menu.Item>
      </Menu>
      <div style={{ float: 'right', marginRight: 20 }}>
        <LanguageSwitcher />
      </div>
    </Header>
  );
};

export default AppHeader; 